export default "__VITE_ASSET__D_xjz020__"